import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './base/intercepter/auth.interceptor';
import { appInterceptor } from './base/intercepter/app.interceptor';
import { loaderInterceptor } from './base/intercepter/loader.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any) {
    if (error.message?.includes('Failed to fetch dynamically imported module')) {
      console.warn('Lazy-loaded chunk error detected. Reloading the application...');
      window.location.reload();
    } else {
      console.error('An unexpected error occurred:', error);
    }
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([authInterceptor, appInterceptor, loaderInterceptor])), 
    provideAnimationsAsync(),
    provideAnimations(),
    provideToastr({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      progressBar: true,
      progressAnimation: 'decreasing',
      closeButton: true,
      preventDuplicates: true,
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};
